import { getSDKConfig } from './config';

export const addEventCount = (event_name) => {
  setTimeout(() => {
    const { GV2_GODAVARI_COUNTER } = window.spnGlobalConfig;

    const config = getSDKConfig();

    if (!config) return;

    const priority_events = config.priority_events;

    if (!Array.isArray(priority_events) || priority_events.length == 0) return;

    if (!priority_events.includes(event_name)) return;

    if (GV2_GODAVARI_COUNTER[event_name]) {
      updateEventCounter(event_name, 'recieved');
      return;
    }

    GV2_GODAVARI_COUNTER[event_name] = {
      recieved: 1,
    };
  });
};

export const updateEventCounter = (event_name, key) => {
  const { GV2_GODAVARI_COUNTER } = window.spnGlobalConfig;
  const currCounts = GV2_GODAVARI_COUNTER[event_name];
  if (!currCounts) return;

  GV2_GODAVARI_COUNTER[event_name][key] = (currCounts[key] || 0) + 1;
};

export const updateEventResponse = (event_data, status) => {
  if (!event_data) return;
  setTimeout(() => {
    const isBatch = Array.isArray(event_data);

    const isPriority = !isBatch;
    if (window?.spnGlobalConfig?.currentSessionId) {
      if (isBatch) {
        event_data.forEach((i) => {
          const { currentSessionId } = window.spnGlobalConfig;
          if (
            currentSessionId !== null &&
            currentSessionId === i?.context?.SessionId
          ) {
            updateEventCounter(i.event_name, `batch_${status}`);
          }
        });
      }
      if (isPriority) {
        const { currentSessionId } = window.spnGlobalConfig;
        if (
          currentSessionId !== null &&
          currentSessionId === event_data?.context?.SessionId
        ) {
          updateEventCounter(event_data.event_name, `priority_${status}`);
        }
      }
    }
  });
};
